import React, { useEffect, useState } from "react";
import Breadcrumb from "../../components/common/BreadCrumb";
import RippleLoader from "../../components/loader/RippleLoader";
import ProductIcon from "../../assets/image/image.png";
import {
  Default,
  Electronic,
  Exhaust,
  FlitterIcon,
  Gas,
  Plumbing,
} from "../../assets/svg";
import FlitterPanel from "./FlitterPanel";
import { Pagination } from "@mui/material";
import TableShowLimit from "../../components/common/TableShowLimit";
import ProductDetails from "./ProductDetails";
import { getCategoriesList, getProductList } from "../../redux/product/slice";
import { useDispatch, useSelector } from "react-redux";

const ProductInterest = () => {
  const dispatch = useDispatch();
  const [showFilter, setShowFilter] = useState(false);
  const [modifiedDate, setModifiedDate] = useState("latest_modified_date");
  const [tempRoles, setTempRoles] = useState(["All"]);
  const [tempPaymentStatus, setTempPaymentStatus] = useState(["All"]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [paginationCurrentLimit, setPaginationCurrentLimit] = useState(10);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showProductModal, setShowProductModal] = useState(false);
  const [pageLimit, setPageLimit] = useState(10);
  const [pageCount, setPageCount] = useState(1);
  const [sortBy, setSortBy] = useState("");
  const [sortDirection, setSortDirection] = useState("desc");

  // selector
  const {
    productsList,
    productsListLoading,
    allCategoriesList,
    allCategoriesLoading,
  } = useSelector((store) => ({
    productsList: store?.productsData?.getProductListStatus?.data?.data,
    productsListLoading: store?.productsData?.loading,
    // all RoleL ist
    allCategoriesList: store?.productsData?.getCategoriesListStatus?.data,
    allCategoriesLoading: store?.productsData?.loading,
  }));

  useEffect(() => {
    dispatch(
      getProductList({
        search: "",
        pageCount: pageCount,
        pageLimit: pageLimit,
        categories_ids: [selectedCategories],
        sort_by: sortBy,
        sort_direction: sortDirection === "asc" ? "asc" : "desc",
      })
    );
    dispatch(getCategoriesList({ search: "", limit: "all" }));
  }, [pageCount, pageLimit, selectedCategories, sortBy, sortDirection]);

  const handleApplyFilter = () => {
    if (modifiedDate === "latest_modified_date") {
      setSortBy("latest");
      setSortDirection("desc");
    } else if (modifiedDate === "price_low") {
      setSortBy("price");
      setSortDirection("asc");
    } else if (modifiedDate === "price_high") {
      setSortBy("price");
      setSortDirection("desc");
    }

    setShowFilter(false);
  };

  const renderCategoryIcon = (categoryName) => {
    switch (categoryName) {
      case "Electrical":
        return <Electronic />;
      case "Gas":
        return <Gas />;
      case "Plumbing":
        return <Plumbing />;
      case "Exhaust":
        return <Exhaust />;
      default:
        return <Default />;
    }
  };

  return (
    <div className="space-y-7">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
        <div>
          <h6 className="font-Montserrat font-medium text-xl mb-3">
            Product Interest
          </h6>
          <Breadcrumb
            breadCrumbParent="Home"
            breadCrumbActive="Product Interest"
            breadCrumbTitleKey="/"
            classes=""
          />
        </div>
      </div>

      {productsListLoading ? (
        <RippleLoader />
      ) : (
        <div className="w-full bg-white shadow rounded-lg p-4 sm:p-6">
          <div className="p-2">
            <div className="flex justify-between mb-2">
              <h6 className="font-Montserrat text-xl font-medium text-themeBtn">
                Our Products
              </h6>
              <div
                className="bg-primaryOrange p-2 rounded cursor-pointer"
                onClick={() => setShowFilter(true)}
              >
                <FlitterIcon />
              </div>
            </div>
          </div>
          {/* Product Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5 gap-4">
            {productsList?.data?.map((item) => {
              const imageUrl = item?.images?.[0]?.document?.url;
              return (
                <div
                  key={item?.id}
                  onClick={() => {
                    setSelectedProduct(item);
                    setShowProductModal(true);
                  }}
                  className="bg-gray-50 rounded-md p-2 transition-all duration-200 hover:shadow-xl cursor-pointer"
                >
                  <img
                    src={imageUrl}
                    alt={item?.name}
                    className="w-full h-24 object-contain mb-3"
                  />
                  <div className="bg-bgproduct p-2 rounded-sm">
                    <h4 className="text-sm truncate font-normal font-Proxima">
                      {item?.name}
                    </h4>
                    <p className="text-[10px] text-gray-dark font-normal font-Proxima flex items-center gap-1">
                      <span className="w-4 h-4 flex items-center justify-center shrink-0">
                        {renderCategoryIcon(item?.category_name)}
                      </span>
                      {item?.category_name}
                    </p>

                    <p className="text-sm font-normal font-Proxima text-themeBtn">
                      ${item?.price}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Pagination */}
          <div className="flex flex-wrap items-center justify-between sm:justify-end my-2">
            <TableShowLimit
              paginationCurrentLimit={paginationCurrentLimit}
              setPaginationCurrentLimit={setPaginationCurrentLimit}
            />
            <p className="text-xs font-Proxima pl-2">
              {`${
                (productsList?.current_page - 1) * productsList?.per_page + 1
              } - ${
                (productsList?.current_page - 1) * productsList?.per_page +
                productsList?.data?.length
              } of ${productsList?.total}`}
            </p>
            <div className="px-4 py-2 rounded-lg">
              <Pagination
                total={productsList?.total}
                lastPage={Math.ceil(productsList?.total / pageLimit)}
                current={pageCount}
                paginationData={(crPage) => setPageCount(crPage)}
              />
            </div>
          </div>
        </div>
      )}
      <FlitterPanel
        show={showFilter}
        onClose={() => setShowFilter(false)}
        onApply={handleApplyFilter}
        roles={tempRoles}
        modifiedDate={modifiedDate}
        setModifiedDate={setModifiedDate}
        setRoles={setTempRoles}
        paymentStatus={tempPaymentStatus}
        setPaymentStatus={setTempPaymentStatus}
        selectedCategories={selectedCategories}
        setSelectedCategories={setSelectedCategories}
        allCategoriesList={allCategoriesList}
        allCategoriesLoading={allCategoriesLoading}
      />
      {showProductModal && selectedProduct && (
        <ProductDetails
          setShowProductModal={setShowProductModal}
          selectedProduct={selectedProduct}
          ProductIcon={ProductIcon}
        />
      )}
    </div>
  );
};

export default ProductInterest;
